// import {ViewModelProvider} from './ViewModelContext';

const IdvNoneContent = () => {
  return <>None</>;
};

const IdvNonePage = () => (
  //   <ViewModelProvider>
  <IdvNoneContent />
  //   </ViewModelProvider>
);

export default IdvNonePage;
